<template>
	<nuxt-link v-if="content?.slug?.current" class="featured row"
						 :to="localePath(`/projects/${content.slug.current}`)"
						 @click="$toggleNav">
		<img v-if="content?.projectHero?.asset?.url" :src="$urlFor(content.projectHero.asset.url, 600)"
				 :alt="heroAlt"
				 class="featured__image col-md-7"
				 loading="lazy"
				 :height="content.projectHero.asset.metadata.dimensions.height"
				 :width="content.projectHero.asset.metadata.dimensions.width"
				 sizes="sm:100vw md:50vw lg:600px" />
		<div class="featured__details col-md-5">
			<h5 class="featured__content-type">{{contentType}}</h5>
			<h3 class="featured__title">{{ contentTitle }}</h3>
			<h5 class="featured__type">{{ projectType }}</h5>
		</div>
	</nuxt-link>
</template>

<script setup>
	import { useI18n, useLocalePath } from '#imports'
	const { locale } = useI18n()
	const localePath = useLocalePath()
  import { computed } from 'vue'
  const props = defineProps({
    content: Object
  })
  const heroAlt = computed(() => locale.value === 'en' ? props.content?.projectHeroAlt?.en : props.content?.projectHeroAlt?.jp)
  const contentType = computed(() => locale.value === 'en' ? 'Featured Project' : '注目のプロジェクト')
  const contentTitle = computed(() => locale.value === 'en' ? props.content?.title?.en : props.content?.title?.jp)
  const projectType = computed(() => locale.value === 'en' ? props.content?.projectType?.en : props.content?.projectType?.jp)
</script>
